module.exports = __webpack_public_path__ + "241c3619e96312cee5265ef174f56ddf.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/boardLogo.svg
// module id = ./Content/boardLogo.svg
// module chunks = 8